<template>
  <div v-if="value">
    <v-tabs
      v-model="tab"
      icons-and-text
      active-class='activeTab'
      show-arrows
      @change="$emit('input', currentDivision)"
      :value='value'
    >
    <v-tabs-slider :color='color'></v-tabs-slider>
      <v-tab
        v-for="div in divs"
        :key="div.id"
      >
        {{ div.division }}
        <v-icon :color='div.icon_color'>{{ div.icon }}</v-icon>
      </v-tab>
    </v-tabs>
      <v-tabs-items v-model='tab'>
        <v-tab-item
          v-for="div in divs"
          :key="div.id"
        >
        <slot name='default'></slot>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'wc-division-tabs',
  props: {
    value: {
      required: true,
    },
    color: {
      required: false,
      default: 'primary'
    }
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    divs () {
      let myDivs = _.orderBy(this.$store.state.misc.divisions, 'order')
      let nextId = _.maxBy(myDivs, function(o) { return o.id })
      myDivs.unshift({id:nextId.id+1, division:"All", icon:"mdi-circle-outline", icon_color: "yellow", archived: "false", is_all: true })
      return myDivs
    },
    currentDivision () {
      return this.divs[this.tab]
    }
  },
  watch: {
    value () {
      if (this.value !== this.currentDivision) {
        this.tab = _.indexOf(this.divs, this.value)
      }
    },
  }
}
</script>

<style scoped>
.activeTab {
  background-color: #F5F5F5;
  border: 1px solid #E0E0E0;
  border-top: none;
  text-decoration: bold;
}
</style>
